"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = advertising;

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _jquery = _interopRequireDefault(require("jquery"));

var _console_utils = _interopRequireDefault(require("./console_utils"));

function advertising() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$targeting = _ref.targeting,
      targeting = _ref$targeting === void 0 ? [] : _ref$targeting,
      _ref$targetingEvent = _ref.targetingEvent,
      targetingEvent = _ref$targetingEvent === void 0 ? '' : _ref$targetingEvent,
      _ref$localStorageKey = _ref.localStorageKey,
      localStorageKey = _ref$localStorageKey === void 0 ? '' : _ref$localStorageKey,
      _ref$waitForConsent = _ref.waitForConsent,
      waitForConsent = _ref$waitForConsent === void 0 ? true : _ref$waitForConsent,
      _ref$waitForPageView = _ref.waitForPageView,
      waitForPageView = _ref$waitForPageView === void 0 ? true : _ref$waitForPageView,
      _ref$waitForWindowLoa = _ref.waitForWindowLoaded,
      waitForWindowLoaded = _ref$waitForWindowLoa === void 0 ? true : _ref$waitForWindowLoa;

  var global_ = window;
  var advertising_config_ = global_.getRpConfig && global_.getRpConfig() && global_.getRpConfig().getPropertyValue('advertising') || {};
  var console_ = (0, _console_utils.default)('advertising', advertising_config_.is_debug);
  var wait_for_consent_ = waitForConsent;
  var wait_for_page_view_ = waitForPageView;
  var wait_for_window_loaded_ = waitForWindowLoaded;

  if (advertising_config_.wait_for_conset !== undefined) {
    wait_for_consent_ = advertising_config_.wait_for_conset;
    console_.warn(".advertising() -> wait_for_conset: ".concat(wait_for_consent_, " defined in getRpConfig().advertising.wait_for_conset"));
  }

  if (advertising_config_.wait_for_page_view !== undefined) {
    wait_for_page_view_ = advertising_config_.wait_for_page_view;
    console_.warn(".advertising() -> wait_for_page_view: ".concat(wait_for_page_view_, " defined in getRpConfig().advertising.wait_for_page_view"));
  }

  console_.info(".advertising() -> wait_for_conset: ".concat(wait_for_consent_, " wait_for_page_view: ").concat(wait_for_page_view_, " targeting: "), targeting, " targetingEvent: \"".concat(targetingEvent, "\" localStorageKey: \"").concat(localStorageKey, "\""));

  if (wait_for_consent_) {
    waitForAdvertisingConsent();
  }

  if (wait_for_page_view_) {
    waitForPageViewEvent();
  }

  if (!wait_for_consent_ && !wait_for_page_view_) {
    startAdvertisingOnWindowLoad();
  }

  function waitForAdvertisingConsent() {
    console_.info('.waitForAdvertisingConsent()');
    global_.addEventListener('RP_ADVERTISING_ALLOWED', startAdvertisingOnConsent);
  }

  function waitForPageViewEvent() {
    console_.info('.waitForPageViewEvent()');
    global_.addEventListener('RP_PAGE_VIEW', startAdvertisingOnPageView);
  }

  function startAdvertisingOnConsent() {
    console_.info('.startAdvertisingOnConsent()');
    wait_for_consent_ = false;
    global_.removeEventListener('RP_ADVERTISING_ALLOWED', startAdvertisingOnConsent);
    startAdvertisingOnWindowLoad();
  }

  function startAdvertisingOnPageView() {
    console_.info('.startAdvertisingOnPageView()');
    wait_for_page_view_ = false;
    global_.removeEventListener('RP_PAGE_VIEW', startAdvertisingOnPageView);
    startAdvertisingOnWindowLoad();
  }

  function startAdvertisingOnWindowLoad() {
    if (wait_for_consent_ || wait_for_page_view_) return;
    console_.info('.startAdvertisingOnWindowLoad()');

    if (!wait_for_window_loaded_ || window.document.readyState === 'complete') // all document resources are loaded
      {
        startAdvertising();
        return;
      }

    (0, _jquery.default)(window).load(startAdvertising);
  }

  function startAdvertising() {
    console_.info('.startAdvertising()');
    var googletag = global_.googletag;
    var pubads = googletag && googletag.pubads && googletag.pubads();

    if (!pubads) {
      console_.warn('.startAdvertising() -> Advertising googletag.pubads() is blocked by third-party plugin, or not configured!');
      return;
    }

    var $global_ = (0, _jquery.default)(global_);
    var $page_ = (0, _jquery.default)('html');
    var targetingEventType = targetingEvent.split('.')[0];
    loadAdvertisingSlotsHtmls();

    function getSlotId(slot_) {
      return slot_.id;
    }

    function onAdsUpdate(callback_) {
      $page_.css('overflow-y', 'hidden');
      callback_();
      $page_.css('overflow-y', 'auto');
    }

    function refreshAdvertisingSlots() {
      console_.log('.refreshAdvertisingSlots()');
      pubads.refresh();
    }

    function updateTargeting() {
      try {
        var preferences_ = JSON.parse(localStorage.getItem(localStorageKey));
        if (!preferences_) return;
        var to_follow_ = targeting.filter(function (key_) {
          return preferences_[key_];
        });
        pubads.setTargeting('to_follow', to_follow_);
        onAdsUpdate(refreshAdvertisingSlots);
      } catch (error_) {
        console_.warn('.updateTargeting() -> failed to retrieve preferences', error_);
      }
    }

    function onPreferenceChange(event_) {
      console_.log('.onPreferenceChange() -> event: ', event_);

      if (event_.type === targetingEventType || event_.key && event_.key === localStorageKey) {
        updateTargeting();
      }
    }

    function attachEvents() {
      $global_.on('rpBreakpointsSwitch', function () {
        onAdsUpdate(refreshAdvertisingSlots);
      });

      if (targeting && targeting.length) {
        $global_.on("storage ".concat(targetingEvent), onPreferenceChange);
      }

      function onSlotRenderEnded(event_) {
        console_.log('.onSlotRenderEnded() -> event: ', event_);
        var $slot_ = (0, _jquery.default)("#".concat(event_.slot.getSlotElementId()));
        if (!$slot_.hasClass('ui-advertising_position1')) return;
        var size_ = Number(event_.size && event_.size[1]) || 0;
        $slot_.height(size_ + 16);
      }

      pubads.addEventListener('slotRenderEnded', onSlotRenderEnded);
    }

    function displayAdvertisingSlots() {
      console_.log('.displayAdvertisingSlots()');

      function displayAdvertisingSlot(slot_id_) {
        console_.log(".displayAdvertisingSlot() -> #slot_id: ".concat(slot_id_));
        global_.googletag.display(slot_id_);
      }

      Array.from((0, _jquery.default)('.js-advertising:visible')).map(getSlotId).forEach(displayAdvertisingSlot);
    }

    function loadAdvertisingSlotsHtmls() {
      var $js_advertising_ = (0, _jquery.default)('#js-advertising');
      var url_ = $js_advertising_.data('url');
      console_.log(".loadAdvertisingSlotsHtmls() -> url: \"".concat(url_, "\" defined on script tag: "), $js_advertising_);

      if (!url_) {
        console_.warn('.loadAdvertisingSlotsHtmls() -> Url for advertising should be defined!');
        return;
      }

      function onAdvertisingJsonLoaded(json_response_) {
        console_.log('.onAdvertisingJsonLoaded() -> json_response: ', json_response_);

        function addHtmlToAdvertisingSlot(slot_) {
          var html_for_slot_ = json_response_[slot_];
          console_.log(".addHtmlToAdvertisingSlot() -> slot: ".concat(slot_, " html_for_slot: "), html_for_slot_);
          if (!validateJsSyntaxForAdvertisingSlot(html_for_slot_, slot_)) return;
          (0, _jquery.default)(".js-advertising__placeholder".concat(slot_)).removeClass('ui-advertising_position1').append((0, _jquery.default)(html_for_slot_));
        }

        function validateJsSyntaxForAdvertisingSlot(html_for_slot_, slot_) {
          console_.log(".validateJsSyntaxForAdvertisingSlot() -> slot: ".concat(slot_));
          var is_valid_ = true;
          var js_ = null;

          try {
            var matches_ = RegExp(/^(<script.*>)([\s\S]*)(<\/script>)/).exec(html_for_slot_);

            if (matches_ === null) {
              console_.warn(".validateJsSyntaxForAdvertisingSlot() -> slot: ".concat(slot_, " no script tag found!"));
              return is_valid_ = true;
            }

            js_ = matches_[2];

            if (js_ === 'null') {
              console_.info(".validateJsSyntaxForAdvertisingSlot() -> slot: ".concat(slot_, " no ad set"));
              return is_valid_ = true;
            }

            new Function('data', js_);
          } catch (error_) {
            console_.error(".validateJsSyntaxForAdvertisingSlot() -> slot: ".concat(slot_, " invalid js:\n").concat(js_, "\nerror: "), error_); //java script is invalid: \n${util.inspect(error_)}`);

            is_valid_ = false;
          }

          return is_valid_;
        }

        Object.keys(json_response_).forEach(addHtmlToAdvertisingSlot);

        if (targeting && targeting.length) {
          updateTargeting();
        }

        onAdsUpdate(displayAdvertisingSlots);
        attachEvents();
      }

      function onAdvertisingJsonLoadError() {
        for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
          rest[_key] = arguments[_key];
        }

        console_.warn(".onAdvertisingJsonLoaded() -> faild to load url: \"".concat(url_, ")\""), rest);
      }

      _jquery.default.getJSON(url_).done(onAdvertisingJsonLoaded).fail(onAdvertisingJsonLoadError);
    }
  }
}

;


//////////////////
// WEBPACK FOOTER
// ./~/rp-advertising/lib/js/advertising.js
// module id = 235
// module chunks = 1